import { render, staticRenderFns } from "./announcementCommon.vue?vue&type=template&id=06110169&scoped=true"
import script from "./announcementCommon.vue?vue&type=script&lang=js"
export * from "./announcementCommon.vue?vue&type=script&lang=js"
import style0 from "./announcementCommon.vue?vue&type=style&index=0&id=06110169&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06110169",
  null
  
)

export default component.exports